import { RouterProvider } from 'react-router-dom';
import { App as AntdApp } from 'antd';
import { AntdConfigProvider } from './components/antd-config-provider';
import { StaticAntd } from './components/static-antd';
import { ThemeProvider } from './components/theme-provider';
import { router } from './router';
import { useEffect, useState } from 'react';
import { socket } from './services/websocket/socketio';

export default function App() {
  // socketio
  const [isConnected, setIsConnected] = useState(socket.connected);
  const [system_performance_overview_data, setSystem_performance_overview_data] = useState({});
  const [socketLoading, setSocketLoading] = useState(false); // 仪表盘中系统性能概览的loading

  useEffect(() => {
    setSocketLoading(true);
    // socket.connect();
    function onConnect() {
      setIsConnected(true);
      socket.emit('join_room', { room_name: 'system_performance_overview' }, (response: any) => {
        console.log(response);
      });
    }

    function onDisconnect() {
      setIsConnected(false);
      setSocketLoading(false);
    }

    function onFooEvent(value: any) {
      setSocketLoading(false);
      setSystem_performance_overview_data(value.data);
    }

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('data_push2client', onFooEvent);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('foo', onFooEvent);
    };
  }, []);
  return (
    <ThemeProvider>
      <AntdConfigProvider>
        <AntdApp>
          <StaticAntd />
          <RouterProvider
            router={router}
            future={{
              v7_startTransition: true,
            }}
          />
        </AntdApp>
      </AntdConfigProvider>
    </ThemeProvider>
  );
}
